// Frontend (ES module) copy of the load-scenario day/MD-label lookup.
// Mirrors the CommonJS copy at the project root (../scenarioDays.js, required by
// server.staging.js / server.production.js) — CRA's webpack config refuses to
// resolve imports outside src/, so a single physically-shared file isn't possible
// here. Keep both copies in sync if SCENARIO_DAYS or the MD-label math changes.

export const SCENARIO_DAYS = {
  '1A': ['MD+1','MD+2','MD+3','MD+4','MD-3','MD-2','MD-1','MD'],
  '1B': ['MD+1','MD+2','MD+3','MD+4','MD-3','MD-2','MD-1','MD'],
  '1C': ['MD+1','MD+2','MD+3','MD+4','MD-3','MD-2','MD-1','MD'],
  '1D': ['MD+1','MD+2','MD+3','MD+4','MD-4','MD-3','MD-2','MD-1','MD'],
  '1E': ['MD+1','MD+2','MD+3','MD-2','MD-1','MD'],
  '2A': ['MD+1','MD+2','MD+3','MD-3','MD-2','MD-1','MD'],
  '2B': ['MD+1','MD+2','MD+3','MD-3','MD-2','MD-1','MD'],
  '2C': ['MD+1','MD+2','MD+3','MD-3','MD-2','MD-1','MD'],
  '3A': ['MD+1','MD+2','MD+3','MD-2','MD-1','MD'],
  '3B': ['MD+1','MD+2','MD+3','MD-2','MD-1','MD'],
  '3C': ['MD+1','MD+2','MD+3','MD-2','MD-1','MD'],
  '3D': ['MD+1','MD+2','MD+3','MD-2','MD-1','MD'],
  '4A': ['MD+1','MD+2','MD-2','MD-1','MD'],
  '4B': ['MD+1','MD+2','MD+3','MD+4','MD'],
  '4C': ['MD+1','MD+2','MD-2','MD-1','MD'],
  '5A': ['MD+1','MD+2','MD-1','MD'],
  '6A': ['MD-2','MD-1','MD'],
  '6B': ['MD+1','MD-1','MD'],
};

export const SCENARIOS = ['1A','1B','1C','1D','1E','2A','2B','2C','3A','3B','3C','3D','4A','4B','4C','5A','6A','6B'];

// Local-time date parsing — matches the frontend's existing display/comparison behavior.
export function parseDate(str) {
  if (!str) return null;
  const s = String(str).trim();
  if (s.includes('/')) { const [d, m, y] = s.split('/'); return new Date(`${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`); }
  return new Date(s);
}

// Given a scenario { scenario, startDate|start_date } and a target date string,
// return the MD label for that date, or null if the date falls outside the scenario's span.
export function getMDForDate(sc, dateStr, daysMap = SCENARIO_DAYS) {
  const start  = parseDate(sc.startDate || sc.start_date);
  const target = parseDate(dateStr);
  if (!start || !target) return null;
  const dayIndex = Math.round((target - start) / 86400000);
  const days = daysMap[sc.scenario];
  if (!days || dayIndex < 0 || dayIndex >= days.length) return null;
  return days[dayIndex];
}
